
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

export function useProgramsDelete(onSuccess: () => Promise<void>) {
  const { toast } = useToast();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeleteSelectedPrograms = async (selectedPrograms: string[]) => {
    if (selectedPrograms.length === 0) return false;
    
    try {
      setIsDeleting(true);
      const { error } = await supabase
        .from('programs')
        .delete()
        .in('program_id', selectedPrograms);
      
      if (error) {
        console.error("Error deleting programs:", error);
        toast({
          title: "Error",
          description: `Failed to delete programs: ${error.message}`,
          variant: "destructive",
        });
        return false;
      }
      
      toast({
        title: "Success",
        description: `${selectedPrograms.length} program(s) deleted successfully`,
      });
      
      // Refresh programs list
      await onSuccess();
      return true;
      
    } catch (error) {
      console.error("Error in handleDeleteSelectedPrograms:", error);
      toast({
        title: "Error",
        description: "An unexpected error occurred while deleting programs",
        variant: "destructive",
      });
      return false;
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    isDeleting,
    handleDeleteSelectedPrograms
  };
}
